import { PakTab } from '@cpak/enums';
import { PakTabs, PaksTotalTabs } from '@cpak/interfaces';
import { QuoteStatuses, PrototypeStatuses } from '@cpak/adp-cpak-quotes-service-models';

export const pakTabsConfig: PakTabs[] = [
  { label: 'all', value: PakTab.All, total: 0, inactive: false },
  { label: 'quotes', value: PakTab.Quote, total: 0, inactive: false },
  { label: 'contracts', value: PakTab.Contract, total: 0, inactive: false },
  { label: 'prototypes', value: PakTab.Prototype, total: 0, inactive: false },
];

export const pakTabToTotalKey = new Map<PakTab, keyof PaksTotalTabs>([
  [PakTab.Quote, 'quotes'],
  [PakTab.Contract, 'contracts'],
  [PakTab.Prototype, 'prototypes'],
  [PakTab.All, 'all'],
]);

const editColor = '#4E0F78';
const requestedColor = '#FF6B12';
const completedColor = '#007483';
const rejectedColor = '#9B1A2F';
const recalledColor = '#003595';

export const PakStatusColor = new Map<string, string>([
  [QuoteStatuses.edit, editColor],
  [QuoteStatuses.validationRequested, requestedColor],
  [QuoteStatuses.customerApprovalRequested, requestedColor],
  [QuoteStatuses.pricingApprovalRequested, requestedColor],
  [QuoteStatuses.prototypeRequested, requestedColor],
  [QuoteStatuses.contractRequested, requestedColor],
  [QuoteStatuses.customerPriceSetup, requestedColor],
  [QuoteStatuses.validationCompleted, completedColor],
  [QuoteStatuses.customerApprovalCompleted, completedColor],
  [QuoteStatuses.pricingApprovalCompleted, completedColor],
  [PrototypeStatuses.prototypeCompleted, completedColor],
  [QuoteStatuses.contractCompleted, completedColor],
  [QuoteStatuses.prototypeRequestCompleted, completedColor],
  [QuoteStatuses.contractRequestCompleted, completedColor],
  [QuoteStatuses.customerPriceSetupCompleted, completedColor],
  [QuoteStatuses.validationRejected, rejectedColor],
  [QuoteStatuses.customerApprovalRejected, rejectedColor],
  [QuoteStatuses.prototypeRequestRejected, rejectedColor],
  [QuoteStatuses.contractRequestRejected, rejectedColor],
  [QuoteStatuses.pricingApprovalRejected, rejectedColor],
  [QuoteStatuses.customerPricingRejected, rejectedColor],
  [QuoteStatuses.customerPriceSetupRecalled, recalledColor],
  [QuoteStatuses.pricingApprovalRecalled, recalledColor],
]);

export const PakStatusText = new Map<string, string>([
  [QuoteStatuses.edit, 'quoteStatusesEdit'],
  [QuoteStatuses.validationRequested, 'quoteStatusesValidationRequested'],
  [QuoteStatuses.validationCompleted, 'quoteStatusesValidationCompleted'],
  [QuoteStatuses.validationRejected, 'quoteStatusesValidationRejected'],
  [QuoteStatuses.customerApprovalRequested, 'quoteStatusesCustomerApprovalRequested'],
  [QuoteStatuses.customerApprovalCompleted, 'quoteStatusesCustomerApprovalCompleted'],
  [QuoteStatuses.customerApprovalRejected, 'quoteStatusesCustomerApprovalRejected'],
  [QuoteStatuses.prototypeRequested, 'quoteStatusesPrototypeRequested'],
  [QuoteStatuses.prototypeRequestCompleted, 'quoteStatusesPrototypeRequestCompleted'],
  [QuoteStatuses.prototypeRequestRejected, 'quoteStatusesPrototypeRequestRejected'],
  [QuoteStatuses.contractRequested, 'quoteStatusesContractRequested'],
  [QuoteStatuses.contractRequestCompleted, 'quoteStatusesContractRequestCompleted'],
  [QuoteStatuses.contractRequestRejected, 'quoteStatusesContractRequestRejected'],
  [QuoteStatuses.pricingApprovalRequested, 'quoteStatusesPricingApprovalRequested'],
  [QuoteStatuses.customerPriceSetup, 'quoteStatusesCustomerPriceSetup'],
  [QuoteStatuses.customerPriceSetupCompleted, 'quoteStatusesCustomerPriceSetupCompleted'],
  [QuoteStatuses.pricingApprovalCompleted, 'quoteStatusesPricingApprovalCompleted'],
  [QuoteStatuses.pricingApprovalRejected, 'quoteStatusesPricingApprovalRejected'],
  [QuoteStatuses.customerPriceSetupRecalled, 'quoteStatusesCustomerPriceSetupRecalled'],
  [QuoteStatuses.pricingApprovalRecalled, 'quoteStatusesPricingApprovalRecalled'],
  [QuoteStatuses.customerPricingRejected, 'quoteStatusesCustomerPricingRejected'],
  [QuoteStatuses.contractCompleted, 'quoteStatusesContractCompleted'],
  [PrototypeStatuses.prototypeCompleted, 'prototypeStatusesPrototypeCompleted'],
]);

export enum TrueBOMLocations {
  MainPak = 'Main Pak',
  GownPak = 'Gown Pak',
  PrepTray = 'Prep Tray',
  GownPak2 = 'Gown Pak2',
  PrepTray2 = 'Prep Tray2',
}
